/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { Link, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import user1 from '../../../assets/images/users/avatar-1.jpg';

// eslint-disable-next-line consistent-return
const getUserName = () => {
  if (localStorage.getItem('authUser')) {
    const obj = JSON.parse(localStorage.getItem('authUser'));
    return obj;
  }
};

class ProfileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      name: 'Admin',
      image: null,
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const userData = getUserName();
    if (userData) {
      this.setState({ name: userData.username, image: userData.profile_image });
    }
  }

  toggle() {
    this.setState((prevState) => ({
      menu: !prevState.menu,
    }));
  }

  render() {
    return (
      <Dropdown
        isOpen={this.state.menu}
        toggle={this.toggle}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          {this.state.image === null && (
            <img
              className="rounded-circle header-profile-user"
              src={user1}
              alt="Header Avatar"
            />
          )}
          {this.state.image !== null && (
            <img
              className="rounded-circle header-profile-user"
              src={this.state.image}
              alt="Header Avatar"
            />
          )}
          {' '}
          <span className="d-none d-xl-inline-block ms-1">
            {this.state.name}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="/profile">
            <i className="bx bx-user font-size-16 align-middle ms-1" />
            &nbsp;
            {this.props.t('Profile')}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{this.props.t('Logout')}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

ProfileMenu.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
};

const mapStateToProps = () => ({ });

export default withRouter(
  connect(mapStateToProps, {})(withTranslation()(ProfileMenu)),
);
